// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Input as NBInput } from 'native-base';
import React, { forwardRef } from 'react';
export const Input = forwardRef(({ variant = 'filled', size = 'md', backgroundColor = 'noChange.white', ...rest }, ref) => {
    return (React.createElement(NBInput, { ref: ref ?? undefined, size: size, backgroundColor: backgroundColor, variant: variant, ...rest }));
});
